var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":0,\"alias\":{\"/assets\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\assets\",\"/static\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\static\"}}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3a26ea77\",\"scoped\":true,\"hasInlineConfig\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./loading.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":0,\"alias\":{\"/assets\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\assets\",\"/static\":\"D:\\\\project\\\\core\\\\core-os\\\\projects\\\\candao-callcenter\\\\static\"}}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3a26ea77\",\"scoped\":false,\"hasInlineConfig\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./loading.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[\"es2015\",\"stage-0\"],\"plugins\":[\"transform-runtime\"]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./loading.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[\"es2015\",\"stage-0\"],\"plugins\":[\"transform-runtime\"]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./loading.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3a26ea77\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./loading.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a26ea77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "components/Cc-Loading/loading.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3a26ea77", Component.options)
  } else {
    hotAPI.reload("data-v-3a26ea77", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./components/Cc-Loading/loading.vue
// module id = kyD3
// module chunks = 0 1 2 3 4 5